import { render, staticRenderFns } from "./iconMenu.vue?vue&type=template&id=655e492e&scoped=true"
import script from "./iconMenu.vue?vue&type=script&lang=js"
export * from "./iconMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655e492e",
  null
  
)

export default component.exports